<template>
  <div>
    <v-row no-gutters> Chips </v-row>
    <v-row>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-chip class="high">High</a-chip>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-chip class="medium">Medium</a-chip>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-chip class="low">Low</a-chip>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-chip outlined class="minute">999 min</a-chip>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-chip outlined class="minute" small>999 min</a-chip>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-chip outlined color="primary" class="opened">OPENED</a-chip>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-chip outlined class="minute">CLOSED</a-chip>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-chip label outlined class="minute">Finance</a-chip>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-chip label outlined class="minute">Risk Management</a-chip>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-chip label outlined class="minute">Investment</a-chip>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AChip from "./AChip.vue";
export default {
  components: { AChip },
  name: "ChipSample",
};
AChip;
</script>

<style scoped>
.card-div {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='black' stroke-width='2' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
}
</style>